<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<content-panel>
  @if (!isSmallScreen && !isDetailOpen) {
    <panel-header
      heading="Credit Submissions"
      class="submission-list-header"
      [showSearchBar]="true"
      [ngClass]="{ 'header-detailopen': isDetailOpen }"
    >
      <app-search-bar
        search
        [fields]="searchFields"
        [defaultField]="'SerialNumber'"
        [activeSearch]="activeSearch"
        (search)="onSearch($event)"
      >
      </app-search-bar>
      <button
        class="headerButton"
        mat-icon-button
        (click)="downloadExcelFile()"
        matTooltip="Download Submissions"
      >
        <mat-icon>download</mat-icon>
      </button>
      <button
        class="headerButton"
        mat-icon-button
        (click)="drawerSvc.openFilter()"
        matTooltip="Filter"
      >
        <mat-icon>filter_alt</mat-icon>
      </button>
      <button
        class="headerButton"
        mat-icon-button
        (click)="openDialog()"
        matTooltip="Add Manual Submission"
      >
        <mat-icon>add</mat-icon>
      </button>
    </panel-header>
  } @else if (!isSmallScreen && isDetailOpen) {
    <panel-header
      heading="Credit Submissions"
      class="submission-list-header"
      [showSearchBar]="true"
      [ngClass]="{ 'header-detailopen': isDetailOpen }"
    >
      <div class="hamburger-menu">
        <button class="headerButton" mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="open-menu">
          <button
            class="menuButton"
            mat-icon-button
            (click)="downloadExcelFile()"
            matTooltip="Download Submissions"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
          >
            <mat-icon class="menuIcon">download</mat-icon>
          </button>
          <button
            class="menuButton"
            mat-icon-button
            (click)="drawerSvc.openFilter()"
            matTooltip="Filter"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
          >
            <mat-icon class="menuIcon">filter_alt</mat-icon>
          </button>
          <button
            class="menuButton"
            mat-icon-button
            (click)="openDialog()"
            matTooltip="Add Manual Submission"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
          >
            <mat-icon class="menuIcon">add</mat-icon>
          </button>
        </mat-menu>
      </div>
      <app-search-bar
        search
        [isDetailView]="isDetailOpen"
        [fields]="searchFields"
        [defaultField]="'SerialNumber'"
        [activeSearch]="activeSearch"
        (search)="onSearch($event)"
      >
      </app-search-bar>
    </panel-header>
  } @else {
    <panel-header
      heading="Credit Submissions"
      class="submission-list-header"
      [showSearchBar]="true"
      [ngClass]="{ 'header-detailopen': isDetailOpen }"
    >
      <div class="hamburger-menu">
        <button class="headerButton" mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="open-menu">
          <button
            class="menuButton"
            mat-icon-button
            (click)="drawerSvc.openFilter()"
            matTooltip="Download Submissions"
            (click)="downloadExcelFile()"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
          >
            <mat-icon class="menuIcon">download</mat-icon>
          </button>
          <button
            class="menuButton"
            mat-icon-button
            (click)="drawerSvc.openFilter()"
            matTooltip="Filter"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
          >
            <mat-icon class="menuIcon">filter_alt</mat-icon>
          </button>
          <button
            class="menuButton"
            mat-icon-button
            (click)="openDialog()"
            matTooltip="Add Manual Submission"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
          >
            <mat-icon class="menuIcon">add</mat-icon>
          </button>
        </mat-menu>
      </div>
      <app-search-bar
        search
        [fields]="searchFields"
        [defaultField]="'SerialNumber'"
        [activeSearch]="activeSearch"
        (search)="onSearch($event)"
      >
      </app-search-bar>
    </panel-header>
  }

  <panel-body id="submissions-panel-body">
    <div class="container container-no-results">
      @if (
        (this.activeSearch ||
          (this.filterSvc.activeFilters != null &&
            this.filterSvc.activeFilters.length > 0)) &&
        dataSource.data.length === 0
      ) {
        <div
          class="no-results-container"
          [ngClass]="{ 'split-view-no-results': isDetailOpen }"
        >
          <p class="no-results-message">No records found</p>
        </div>
      } @else if (isDetailOpen || isMobile) {
        @for (element of dataSource.data; track element.Id) {
          <section
            mat-ripple
            class="list-row-container"
            [ngClass]="activeSubmission?.Id === element.Id ? 'active' : ''"
            (click)="rowSelected(element.Id)"
          >
            <h2 class="primary-content-container">
              {{ element.FacilityNumber }} - {{ element.SerialNumber }}
            </h2>
            <div class="secondary-content-container">
              <div>
                Version:
                <div class="secondary-data-bold">{{ element.Version }}</div>
              </div>
              <div>
                Status:
                <div class="secondary-data-bold">{{ element.Status }}</div>
              </div>
              <div>
                Sold On:
                <div style="width: 180px">
                  <div class="secondary-data-bold">
                    {{ formatDateUTC(element.SoldDate) }}
                  </div>
                  @if (
                    element.SoldDate &&
                    this.isOlderThan90Days(element.SoldDate) &&
                    element.Status !== 'Submitted' &&
                    element.Status !== 'Submitted Manually'
                  ) {
                    <mat-icon
                      [matTooltip]="soldToolTip"
                      class="ninety-day-secondary"
                      >info</mat-icon
                    >
                  }
                </div>
              </div>
            </div>
          </section>
        }
      } @else {
        <section [ngClass]="{ 'below-1150-table': isBelow1150 }">
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="sortChange.emit($event)"
          >
            @for (column of tableColumns; track column) {
              <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <b> {{ formatColumnHeader(column) }}</b>
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (column === this.subConstants.tableColumns.SOLD_DATE) {
                    <div style="width: 150px">
                      {{ formatDateUTC(element[column]) }}
                      @if (
                        element[column] &&
                        this.isOlderThan90Days(element[column]) &&
                        element.Status !== 'Submitted' &&
                        element.Status !== 'Submitted Manually'
                      ) {
                        <mat-icon [matTooltip]="soldToolTip" class="ninety-day"
                          >info</mat-icon
                        >
                      }
                    </div>
                  } @else if (
                    column === this.subConstants.tableColumns.CERTIFICATE_MAILED
                  ) {
                    <div class="column-center">
                      {{
                        element[column] === null
                          ? ''
                          : element[column]
                            ? 'Yes'
                            : 'No'
                      }}
                    </div>
                  } @else if (
                    column ===
                    this.subConstants.tableColumns.SUBMISSION_CREATE_DATE
                  ) {
                    <div class="column-center">
                      {{ formatDateUTC(element[column]) }}
                    </div>
                  } @else if (
                    column === this.subConstants.tableColumns.FURNACE_TYPE
                  ) {
                    <div class="column-center">{{ element[column] }}</div>
                  } @else if (
                    column ===
                    this.subConstants.tableColumns.HEAT_PUMP_INVOICE_AVAILABLE
                  ) {
                    @if (element[column] === true) {
                      <div class="column-center-flex">
                        {{ element[column] ? 'Yes' : 'No' }}
                        <mat-icon [matTooltip]="heatPumpInvoiceAvailableToolTip"
                          >info</mat-icon
                        >
                      </div>
                    } @else {
                      <div class="column-center">
                        {{ element[column] ? 'Yes' : 'No' }}
                      </div>
                    }
                  } @else {
                    {{ element[column] }}
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: tableColumns"
              (click)="rowSelected(row.Id)"
            ></tr>
          </table>
        </section>
      }
    </div>
  </panel-body>
  @if (isDetailOpen || isSmallScreen) {
    <mat-paginator
      class="list-pagination detail-open"
      [pageSize]="paginatorOptions.pageSize"
      [length]="paginatorOptions.pageLength"
      [pageIndex]="materialPageIndex"
      (page)="onPageChangeEvent($event)"
    >
    </mat-paginator>
  } @else {
    <mat-paginator
      class="list-pagination"
      [pageSizeOptions]="paginatorOptions.pageSizeOptions"
      [pageSize]="paginatorOptions.pageSize"
      [length]="paginatorOptions.pageLength"
      [pageIndex]="materialPageIndex"
      [showFirstLastButtons]="paginatorOptions.showFirstLastButtons"
      (page)="onPageChangeEvent($event)"
    >
    </mat-paginator>
  }
</content-panel>
